/**
 * CommonShell과 전역 오버레이가 공유하는 역할 기반 z-index 토큰입니다.
 */
export const zIndex = {
  localBase: 0,
  widgetLocalOverlay: 100,
  boardFeedback: 1200,
  shellChrome: 9000,
  shellChromePopover: 9010,
  widgetElevated: 11020,
  widgetToolbar: 11030,
  widgetTooltip: 11050,
  boardPanelOverlay: 11200,
  boardPanel: 11210,
  boardPanelPopover: 11220,
  blockingOverlay: 12000,
  blockingContent: 12010,
  blockingPopover: 12020,
  realtimeNotification: 13000,
  legacyEmergency: 100000,
} as const;
